import { FaChess, FaChessPawn } from "react-icons/fa";
import { FiCpu, FiLink, FiUsers } from "react-icons/fi";
import { SiLichess, SiWhatsapp } from "react-icons/si";
import Container from "../components/layout/Container";
import PageHeader from "../components/layout/PageHeader";
import MediaCard from "../components/ui/MediaCard";
import VideoStack from "../components/ui/VideoStack";
import { chess, isListed } from "../data/site";

const accountIcons = {
  Lichess: SiLichess,
  "Lichess team": FiUsers,
  "Chess.com": FaChessPawn,
  "Chess.com team": FiUsers,
  Bot: FiCpu,
  "WhatsApp channel": SiWhatsapp,
  "WhatsApp community": SiWhatsapp,
  More: FiLink,
};

function GoldLink({ href, icon: Icon, children }) {
  const label = (
    <span className="inline-flex items-center gap-2">
      {Icon ? <Icon aria-hidden="true" size={16} /> : null}
      {children}
    </span>
  );

  if (!href) {
    return <div className="gold-chip">{label}</div>;
  }

  return (
    <a className="gold-chip" href={href} target="_blank" rel="noopener noreferrer">
      {label}
      <span aria-hidden="true">↗</span>
      <span className="sr-only"> (opens in a new tab)</span>
    </a>
  );
}

export default function ChessPage() {
  const teaching = chess.teaching;
  const courseVideo = chess.course.video;

  return (
    <>
      <PageHeader
        title={chess.name}
        lede={chess.lede}
        mark
        logo={<FaChess aria-hidden="true" size={36} className="shrink-0 text-[var(--kicker)]" />}
      />
      <Container className="pb-24">
        <p className="max-w-2xl text-lg leading-relaxed text-[var(--text)]">{chess.body}</p>

        <section className="mt-14">
          <h2 className="kicker">Accounts</h2>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {chess.accounts.map((account) => (
              <li key={account.label}>
                <GoldLink href={account.href} icon={accountIcons[account.label]}>
                  {account.label}
                </GoldLink>
              </li>
            ))}
          </ul>
        </section>

        <section className="mt-14 border-t border-[var(--line)] pt-10">
          <h2 className="kicker">{chess.course.label}</h2>
          <p className="mt-4 max-w-xl leading-relaxed text-[var(--text)]">{chess.course.text}</p>
          <div className="mt-6 grid gap-4 md:grid-cols-2">
            <MediaCard
              href={chess.course.href}
              image={chess.course.image}
              kicker={chess.course.label}
              title={chess.course.title}
              action={chess.course.action}
              poster={chess.course.poster}
            />
            {courseVideo?.href ? (
              <MediaCard
                href={courseVideo.href}
                image={courseVideo.image}
                kicker={chess.course.label}
                title={courseVideo.title}
                action={courseVideo.action}
                poster={chess.course.poster}
                video
              />
            ) : null}
          </div>
        </section>

        <section className="mt-14 border-t border-[var(--line)] pt-10">
          <h2 className="kicker">Shorts</h2>
          <VideoStack items={chess.videos} poster="chess" place="page" />
        </section>

        {isListed(teaching) ? (
          <section className="mt-14 border-t border-[var(--line)] pt-10">
            <h2 className="kicker">{teaching.title}</h2>
            <div className="mt-6 grid gap-4 md:grid-cols-2">
              {teaching.items
                .filter((item) => item.enabled !== false && item.href && item.page !== false)
                .map((item) => (
                  <MediaCard
                    key={item.title}
                    href={item.href}
                    image={item.image}
                    kicker={teaching.title}
                    title={item.title}
                    action={item.action}
                    poster={item.poster || "chess"}
                    video={item.video === true}
                  />
                ))}
            </div>
          </section>
        ) : null}
      </Container>
    </>
  );
}
